module.exports = global["surveylab_survey_confirmBrowseAway"] = require("-!/app/node_modules/ts-loader/index.js??ref--4!./confirm-browse-away.ts");